import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { size, getBool, getStyle } from 'styles';
import { itemRow } from 'styles/layout';
import { Detail } from '../text';
import { ReactComponent as CloseIcon } from './close.svg';

const Button = styled.button`
  ${itemRow};
  justify-content: center;
  cursor: pointer;
  height: ${size(8)};
  width: ${size(24)};
  border-radius: ${size(6)};
  padding: 0 ${size(2)};
  transition: ${getStyle('hue')};
  background: none;
  border: none;
  background: ${getStyle('black')};
  span {
    color: ${getStyle('white')};
  }
  svg {
    color: ${getStyle('white')};
    width: ${size(3)};
    height: ${size(3)};
  }
  &:hover,
  &:active,
  &:focus {
    opacity: 0.65;
  }
  ${getBool(
    'isActive',
    '',
    `
      opacity: 0 !important;
      pointer-events: none;
    `,
  )}
`;

const ClearButton = ({ className, clearSearch, isActive }) => (
  <Button
    className={className}
    onClick={isActive ? clearSearch : () => {}}
    isActive={isActive}
  >
    <CloseIcon />
    <Detail>Clear</Detail>
  </Button>
);

ClearButton.propTypes = {
  className: PropTypes.string.isRequired,
  clearSearch: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default ClearButton;
